import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../app.service';
import {DatePipe} from '@angular/common';
declare let $: any;
declare let window: any;

@Component({
  selector: 'home-page',
  templateUrl: './homePage.component.html',
  styleUrls: ['./homePage.component.css']
})
export class HomePageComponent implements OnInit, AfterViewInit {
  player;
  loadingOpacity = 1;
  dimInterval;
  revealInterval;

  constructor(public app: AppService, private dp: DatePipe) {

  }

  ngOnInit() {
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
  }

  ngAfterViewInit() {
    this.player = new (<any>window).YT.Player('ytPlayer', {
      events: {
        playerVars: {
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          wmode: 'transparent'
        },
        'onStateChange': (event) => {
          console.log("State change: ", event);
          this.updateFrame(event);
        }
      }
    });
  }

  runDimInterval() {
    setTimeout(() => {
      this.dimInterval = setInterval(() => {
        if (this.loadingOpacity < 1) {
          this.loadingOpacity = this.loadingOpacity + .01;
        } else {
          clearInterval(this.dimInterval);
        }
      }, 10);
    }, 21200);
  }

  runRevealInterval() {
      this.revealInterval = setInterval(() => {
        if (this.loadingOpacity > 0) {
          this.loadingOpacity = this.loadingOpacity - .01;
        } else {
          clearInterval(this.revealInterval);
        }
      }, 10);
  }

  updateFrame(event) {
    switch(event.data) {
      case 1: //Playing
        this.runRevealInterval();
        this.runDimInterval();
        break;
      case 3: //Buffering
        this.loadingOpacity = 1;
        break;
      default:
        break;
    }
  }

  getEditBoxHeight() {
    let width = window.innerWidth < 1400 ? "100%" : "100%";
    let height = 800;
    return {'height': height + 'px', 'width': width};
  }

  goToCardCreatorConsole() {
    this.app.appMode = 0;
  }

  goToManageCards() {
    this.app.appMode = 0;
    setTimeout(() => {
      this.app.broadcast({event: 'viewMyCards'});
    }, 500);
  }

  goToSponsorConsole() {
    this.app.appMode = 2;
    this.app.broadcast({event: 'loadSponsorConsole'});
  }

  changePlayingGame(val) {
    this.app.appMode = val ? 1 : 0;
    if (!val) {
      console.log("Going to sponsor page");
    }
  }

  broadCastHandle(value: Object): void {
    switch(value['event']) {
      default:
        break;
    }
  }

  showVerifyAccountPopup() {

  }
}
